module.exports = __webpack_public_path__ + "static/img/fs1-5.81a5973.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-5.png
// module id = 845
// module chunks = 0